// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps

export const Customers: React.FC<Props> = (props) => {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g opacity="0.34">
        <path d="M4.6665 9.33398H5.99984V10.6673H4.6665V9.33398Z" fill="black" />
        <path d="M12.6667 1.33325H7.33333C6.97971 1.33325 6.64057 1.47373 6.39052 1.72378C6.14048 1.97382 6 2.31296 6 2.66659V6.66659H3.33333C2.598 6.66659 2 7.26459 2 7.99992V13.9999C2 14.1767 2.07024 14.3463 2.19526 14.4713C2.32029 14.5963 2.48986 14.6666 2.66667 14.6666H13.3333C13.5101 14.6666 13.6797 14.5963 13.8047 14.4713C13.9298 14.3463 14 14.1767 14 13.9999V2.66659C14 2.31296 13.8595 1.97382 13.6095 1.72378C13.3594 1.47373 13.0203 1.33325 12.6667 1.33325ZM3.33333 13.3333V7.99992H7.33333V13.3333H3.33333ZM9.33333 5.33325H8V3.99992H9.33333V5.33325ZM12 10.6666H10.6667V9.33325H12V10.6666ZM12 7.99992H10.6667V6.66659H12V7.99992ZM12 5.33325H10.6667V3.99992H12V5.33325Z" fill="black" />
      </g>
    </SvgIcon>
  );
};